import { useQuery } from '@tanstack/react-query';
import { configSIService } from '../../services/configSIService';

export const SI_CONFIG_QUERY_KEYS = {
  catalogoAcesso: ['si', 'config', 'catalogo-acesso'] as const,
  tiposEquipamento: ['si', 'config', 'tipos-equipamento'] as const,
  tiposSolicitacao: ['si', 'config', 'tipos-solicitacao'] as const,
  regrasCliente: ['si', 'config', 'regras-cliente'] as const,
};

// staleTime mais longo que o default global — configuração muda raramente
// (mesmo raciocínio de outras coleções de lookup no Radar, ex. departments/positions).
const CONFIG_STALE_TIME = 5 * 60 * 1000;

export function useCatalogoAcessoQuery() {
  return useQuery({
    queryKey: SI_CONFIG_QUERY_KEYS.catalogoAcesso,
    queryFn: () => configSIService.getCatalogoAcesso(),
    staleTime: CONFIG_STALE_TIME,
  });
}

export function useTiposEquipamentoQuery() {
  return useQuery({
    queryKey: SI_CONFIG_QUERY_KEYS.tiposEquipamento,
    queryFn: () => configSIService.getTiposEquipamento(),
    staleTime: CONFIG_STALE_TIME,
  });
}

export function useTiposSolicitacaoQuery() {
  return useQuery({
    queryKey: SI_CONFIG_QUERY_KEYS.tiposSolicitacao,
    queryFn: () => configSIService.getTiposSolicitacao(),
    staleTime: CONFIG_STALE_TIME,
  });
}

export function useRegrasClienteQuery() {
  return useQuery({
    queryKey: SI_CONFIG_QUERY_KEYS.regrasCliente,
    queryFn: () => configSIService.getRegrasCliente(),
    staleTime: CONFIG_STALE_TIME,
  });
}
